import React from "react";
import "./search-filler.css";

export default function SearchFiller(props) {
  return (
    <div className="search-filler">
      <p className="filler-line-one">Come give us a try,</p>
      <p className="filler-line-two"> and see where you're going to go next.</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/search-filler/index.js